import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00F5FF',
      light: '#33F7FF',
      dark: '#00D9E6',
    },
    secondary: {
      main: '#FF6B35',
      light: '#FF8A5E',
      dark: '#E55A2B',
    },
    background: {
      default: '#0B0D17',
      paper: 'rgba(21, 24, 35, 0.6)',
    },
    text: {
      primary: '#F8F9FA',
      secondary: '#B0B8C1',
    },
  },
  typography: {
    fontFamily: "'Manrope', sans-serif",
    h1: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 900,
    },
    h2: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 700,
    },
    h3: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "'Playfair Display', serif",
      fontWeight: 600,
    },
    code: {
      fontFamily: "'Fira Code', monospace",
    }
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
        },
      },
    },
  },
});

export default theme;
